import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCampaignMetrics } from '../actions/createScheduleAction';
import { H1 } from '@amzn/stencil-react-components/text';
import { Col, View } from '@amzn/stencil-react-components/layout';
import { Flex } from '@amzn/stencil-react-components/layout';
import { Input } from '@amzn/stencil-react-components/input';
import { Label, Text } from '@amzn/stencil-react-components/text';

import '../styles/CreatedSegments.css';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { FormattedMessage } from 'react-intl';
import ButtonLink from '../components/common/ButtonLink';

import { SCHEDULING_LANDING_PAGE } from '../constants/routesConstant';
import ExpanderRow from '../components/campaign/campaign-list/ExpanderRow';

import groupBy from 'lodash/groupBy';
import { campaignListSelector } from '../selectors/selectors';
import isEmpty from 'lodash/isEmpty';
import { useUserInfo } from '../hooks/useUserInfo';
import { campaignListFormatter } from '../util/campaign/campaignUtils';

import { IconSearchSmall } from '@amzn/stencil-react-icons';

export const CreateCampaignLink = () => (
  <ButtonLink to={SCHEDULING_LANDING_PAGE}>
    <FormattedMessage
      id="app.campaigns.btn.createCampaign"
      defaultMessage="Create a nudge campaign"
    />
  </ButtonLink>
);

export const CampaignList = () => {
  const dispatch = useDispatch();
  const createdCampaigns = useSelector(campaignListSelector);
  const formattedCampaigns = campaignListFormatter(createdCampaigns?.response?.campaigns);
  const formattedData = groupBy(formattedCampaigns, 'campaignName');
  const userInfo = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      await dispatch(getAllCampaignMetrics({ userName: userInfo.userName }, userInfo.idToken));
      setIsLoading(false);
    })();
  }, []);

  useEffect(
    () => {
      setFilteredData(Object.keys(formattedData));
    },
    [createdCampaigns?.status],
  );

  const onCampaignSearch = useCallback(
    input => {
      const text = input;
      setSearchText(text);
      const filteredRecords = Object.keys(formattedData).filter(key =>
        key.toLowerCase().includes(text.toLowerCase()),
      );
      setFilteredData(filteredRecords);
    },
    [searchText],
  );

  return (
    <>
      <Col gridGap="S300" width="98%">
        <View>
          <H1>
            <FormattedMessage
              id="app.campaigns.label.createdCampaigns"
              defaultMessage="Campaigns"
            />
          </H1>
        </View>
        <View flex="1" flexDirection="row" alignItems="flex-end" alignSelf="flex-end">
          <CreateCampaignLink />
        </View>
        <View>
          <Text>
            <FormattedMessage
              id="app.campaignList.label.createdCampaign"
              defaultMessage="Created Campaigns"
            />{' '}
            ({Object.keys(formattedData).length || 0})
          </Text>
        </View>
        <Flex flexDirection="row" gridGap="S100">
          <Col width="40%">
            <Label htmlFor="some-search-field" id="some-search-label">
              <FormattedMessage
                id="app.createdSegments.label.searchCampaign"
                defaultMessage="Search campaign"
              />
            </Label>
            <Input
              id="segmentSearch"
              value={searchText}
              iconLeft={IconSearchSmall}
              onChange={e => {
                onCampaignSearch(e?.target.value);
              }}
            />
          </Col>
        </Flex>

        <Col>
          {isLoading ? <Spinner size={SpinnerSize.Large} /> : null}
          {!isLoading ? (
            <Col gridGap="S300">
              {!isEmpty(filteredData) &&
                filteredData?.map(key => (
                  <ExpanderRow
                    name={key}
                    status={formattedData[key]?.[0]?.status}
                    metrics={formattedData[key]}
                  />
                ))}
            </Col>
          ) : null}
        </Col>
      </Col>
    </>
  );
};
